import type { ReactNode } from 'react';

import { TONES, type StageTone } from './tones';

/** A status pill in the payouts palette. */
export function StagePill({ tone, children }: { tone: StageTone; children: ReactNode }) {
  return (
    <span
      className={`inline-flex items-center gap-1.5 whitespace-nowrap rounded-full px-2.5 py-0.5 text-[11.5px] font-bold ring-1 ring-inset ${TONES[tone].pill}`}
    >
      <span className={`h-1.5 w-1.5 rounded-full ${TONES[tone].solid}`} aria-hidden />
      {children}
    </span>
  );
}
